import * as React from 'react';
import {Navigation} from "../../api";
import {useSearchParams} from "react-router-dom";

interface INavigationComponent {
    navigation: Navigation;
}

export const NavigationComponent: React.FC<INavigationComponent> = ({navigation}) => {

        const [searchParams, setSearchParams] = useSearchParams();

        function selectPage() {
            setSearchParams(params => {
                // note: filters are intentionally disregarded to prevent users from navigating to a page with zero results
                params.set("navigation", navigation.id.toString());
                params.set("page", "0");
                return params;
            });
        }

        function isSelected() {
            return searchParams.get("navigation") === navigation.id.toString();
        }

        function renderChildren() {
            if (navigation.children && navigation.children.length > 0) {
                return (
                    <ul className="navigation-list" key={navigation.id + "_children"}>
                        {
                            navigation.children.map((child) => {
                                return <NavigationComponent navigation={child}/>;
                            })}
                    </ul>
                );
            }
            return "";
        }

        return (
            <li key={navigation.id}>
                <span className={"navigation-entry" + (
                    isSelected() ? " selected" : "")} role="button"
                      onClick={selectPage}>{navigation.label}</span>
                {renderChildren()}
            </li>
        );
    }
;
export default NavigationComponent;
